import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfileContactSection
} from './StaffProfileTemplate';

const AkumjungPongenProfile = () => {
  const person = {
    id: "akumjung-pongen",
    name: "Akumjung Pongen",
    honorific: null,
    title: "Graduate Student in Philosophy",
    affiliation: "Christ Church, University of Oxford",
    image: "https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/rf70thdt_Akumjung%20Pongen.jpg",
    email: "akumjung.pongen@chch.ox.ac.uk",
    category: "Fellows & Visiting Scholars",
    testid: "akumjung-pongen-profile"
  };

  return (
    <StaffProfileTemplate person={person}>
      {/* Intellectual Biography */}
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            "Akumjung Pongen is a graduate student in philosophy trained primarily in metaphysics, philosophy of language, and philosophy of religion. He took up a BA in Philosophy at St Stephen's College, Delhi, after which he pursued graduate studies at the University of Oxford on a Rhodes Scholarship.",
            "His intellectual trajectory reflects a deep commitment to foundational questions about existence, meaning, and the nature of truth. As a philosopher engaged with both analytic traditions and broader questions of human understanding, Akumjung brings a distinctive perspective shaped by his educational journey from Delhi to Oxford."
          ]}
        />
      </ProfileSection>

      {/* Research Foci & Areas of Work */}
      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          intro="Akumjung's research engages with fundamental questions in philosophy, spanning several interconnected areas:"
          items={[
            "Metaphysics — exploring the fundamental nature of reality and existence",
            "Philosophy of language — investigating meaning, truth, and reference",
            "Philosophy of religion — examining the philosophical dimensions of religious thought and practice",
            "The nature of existence and ontological inquiry",
            "Education, mentorship, and the humanities"
          ]}
        />
      </ProfileSection>

      {/* Highland Institute Projects */}
      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            "Akumjung is primarily engaged with the Institute's School of Advanced Studies, serving as coordinator alongside Michael T. Heneise (President), Catriona Child (Executive Director) amongst others, and tutor in philosophy for the past few years.",
            "His role at the Institute reflects a commitment to bringing rigorous philosophical training to students in Northeast India, bridging his academic formation at Oxford with the Institute's mission of fostering intellectual development in the region."
          ]}
        />
      </ProfileSection>

      {/* Public Engagement, Teaching & Community Work */}
      <ProfileSection title="Public Engagement, Teaching & Community Work">
        <ProfileParagraphs
          items={[
            "Akumjung's public engagement primarily comes from his association with the School of Advanced Studies. His main work involves teaching philosophy as part of the Summer School, delivering lectures and presentations, and grading student tutorial essays.",
            "As a tutor in philosophy for the past few years, he has contributed to shaping the philosophical education of emerging scholars at the Highland Institute, bringing the rigour of Oxford-style tutorials to the Summer School programme."
          ]}
        />
      </ProfileSection>

      {/* Contact & Scholarly Infrastructure */}
      <ProfileContactSection
        email="akumjung.pongen@chch.ox.ac.uk"
        role="Highland Fellow; Coordinator & Philosophy Tutor, School of Advanced Studies"
        affiliationLines={[
          "Christ Church, University of Oxford",
          "St Aldates, OX1 1DP",
          "United Kingdom"
        ]}
        scholarlyProfiles={[
          { label: "Secondary Email: akumjungpongen@gmail.com", url: "mailto:akumjungpongen@gmail.com", testid: "akumjung-secondary-email" }
        ]}
        testidPrefix="akumjung"
      />
    </StaffProfileTemplate>
  );
};

export default AkumjungPongenProfile;
